import React from "react";
import { motion } from 'framer-motion';
import Verify from '../../assets/Verfiy.svg'
import { InfiniteStack2 } from "./inifiniteStack";

import img1 from '../../assets/Clients Logo/2.jpg'
import img2 from '../../assets/Clients Logo/1.jpg'
import img3 from '../../assets/Clients Logo/3.jpg'
import img4 from '../../assets/Clients Logo/4.jpg'
import img5 from '../../assets/Clients Logo/5.jpg'
import img6 from '../../assets/Clients Logo/6.jpg'
import img7 from '../../assets/Clients Logo/7.jpg'
import img8 from '../../assets/Clients Logo/8.jpg'
import img9 from '../../assets/Clients Logo/9.jpg'
import img10 from '../../assets/Clients Logo/10.jpg'
import img11 from '../../assets/Clients Logo/11.jpg'
import img12 from '../../assets/Clients Logo/12.jpg'
import img13 from '../../assets/Clients Logo/13.jpg'
import img14 from '../../assets/Clients Logo/14.jpg'

const Clientttttt = () => {
  const stack1 = [
    {
      name: "Suvam Rai",
      img: img1,
      text: "Amazing Work and awesome web App bro 💯👌",
    },
    {
      name: "Devang Kartik",
      img: img2,
      text: "It's different and amazing 👍",
    },
    {
      name: "Apoorv Gusain",
      img: img3,
      text: "Amazing UI you have created, I love how you have used animation and how it supports 6 languages.",
    },
    {
      name: "Keshav Agrawal",
      img: img4,
      text: "Amazing Work",
    },
    {
      name: "Vishnu Gajmal",
      img: img5,
      text: "Excellent 💥👍 Keep it up bro👍",
    },
    {
      name: "Rithik Jain",
      img: img6,
      text: "Absolutely amazing UI 👏👏",
    },
    {
      name: "Debopriyo Basu",
      img: img7,
      text: "Great work bro",
    },
    {
      name: "Ketuman Vishwakarma",
      img: img8,
      text: "Such a cool project! ✨",
    },
    {
      name: "Abhishek Bhikule",
      img: img9,
      text: "Great project 💥 👍",
    },
    {
      name: "Harshit Tyagi",
      img: img10,
      text: "Amazing! Great work",
    },
    {
      name: "Mohit Bodhija",
      img: img11,
      text: "Superb 👌",
    },
    {
      name: "Kaushal Kishore",
      img: img12,
      text: "Inspiring project, keep building!!",
    },
    {
      name: "Amrita Bera",
      img: img13,
      text: "Wow! Amazing 🔥",
    },
    {
      name: "Kiran Mahajan",
      img: img14,
      text: "Damn good bro🔥",
    },
  ];

  // const stack1 = [
  //     {
  //         name: "Sanjay Sachithanandham ",
  //         img: 'https://firebasestorage.googleapis.com/v0/b/updatedwebsite-d336b.appspot.com/o/clients%2FSanjaySachithanandham%2CCEO%2C%20Meetcute%20LLC.jpeg?alt=media&token=2118d34e-4847-4317-abfd-fe10dc7f1699',
  //         text: "Brovitech takes complete ownership of the apps and the quality of the Apps developed has always been a priority for them.",
  //         title: 'CEO, Meetcute LLC'
  //     },
  //     {
  //         name: "Sanjay Sachithanandham ",
  //         img: 'https://firebasestorage.googleapis.com/v0/b/updatedwebsite-d336b.appspot.com/o/clients%2FSanjaySachithanandham%2CCEO%2C%20Meetcute%20LLC.jpeg?alt=media&token=2118d34e-4847-4317-abfd-fe10dc7f1699',
  //         text: "Brovitech takes complete ownership of the apps and the quality of the Apps developed has always been a priority for them.",
  //         title: 'CEO, Meetcute LLC'
  //     },
  //     {
  //         name: "Sanjay Sachithanandham ",
  //         img: 'https://firebasestorage.googleapis.com/v0/b/updatedwebsite-d336b.appspot.com/o/clients%2FSanjaySachithanandham%2CCEO%2C%20Meetcute%20LLC.jpeg?alt=media&token=2118d34e-4847-4317-abfd-fe10dc7f1699',
  //         text: "Brovitech takes complete ownership of the apps and the quality of the Apps developed has always been a priority for them.",
  //         title: 'CEO, Meetcute LLC'
  //     },
  //     {
  //         name: "Sanjay Sachithanandham ",
  //         img: 'https://firebasestorage.googleapis.com/v0/b/updatedwebsite-d336b.appspot.com/o/clients%2FSanjaySachithanandham%2CCEO%2C%20Meetcute%20LLC.jpeg?alt=media&token=2118d34e-4847-4317-abfd-fe10dc7f1699',
  //         text: "Brovitech takes complete ownership of the apps and the quality of the Apps developed has always been a priority for them.",
  //         title: 'CEO, Meetcute LLC'
  //     },

  // ];

  const animationProps = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: false, amount: 0.9 },
    transition: { duration: 1.5, delay: 0.01 }
  };

  return (
    <div id="reviews" className="flex justify-center   my-16 sm:my-24 lg:my-28 gap-10  px-4 lg:px-0 items-center flex-col">
      <div className="flex w-full justify-center mb-8 items-center flex-col ">
        <motion.img
          src={Verify}
          className="lg:w-20 sm:w-16 w-8 filter"
          alt="verify"
          initial={{ scale: 0, rotate: -45 }}
          whileInView={{ scale: 1, rotate: 0 }}
          viewport={{ once: true }}
          animate={{ y: [0, -8, 0] }}
          transition={{
            y: {
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut"
            },
            scale: {
              type: "spring",
              stiffness: 260,
              damping: 20
            },
            rotate: {
              type: "spring",
              stiffness: 260,
              damping: 20
            }
          }}
        />
        {/* <span className="text-5xl font-dancing text-zinc-200/25">My</span> */}
        <motion.h2 {...animationProps} className="bg-clip-text text-transparent text-center bg-gradient-to-b from-neutral-800 to-neutral-900 dark:from-neutral-300/90  dark:to-white text-5xl md:text-6xl lg:text-6xl font-sans py-5 md:py-6 relative z-20 font-semibold tracking-tight">What{' '}
          <span className="dark:text-white text-black dancing px-1">People</span>{" "}Are Saying
        </motion.h2>

        <span className="text-center text-lg sm:text-xl lg:text-2xl font-light dark:text-zinc-400/80 text-zinc-900/80 tracking-wide">Hear directly from community users about their experience with my projects!
        </span>
      </div>


      <div className="relative flex justify-center items-center gap-10 overflow-hidden h-[500px] ">
        {/* Gradient overlay at the top */}
        <div className="absolute top-0 left-0 w-full h-16 bg-gradient-to-b dark:from-black from-white to-transparent pointer-events-none z-20" />
        {/* Gradient overlay at the bottom */}
        <div className="absolute bottom-0 left-0 w-full h-16 bg-gradient-to-t dark:from-black from-white  to-transparent pointer-events-none z-20" />

        {/* Column 1 - Scroll Up */}
        <div className="flex-1 flex justify-center">
          <InfiniteStack2 items={stack1} direction="up" speed="slow" />
        </div>
        {/* Column 2 - Scroll Down */}
        <div className="flex-1 flex justify-center">
          <InfiniteStack2 items={stack1} direction="down" speed="mid" />
        </div>
        {/* Column 3 - Scroll Up */}
        <div className="flex-1 flex justify-center">
          <InfiniteStack2 items={stack1} direction="up" speed="fast" />
        </div>
      </div>

    </div>
  );
}

// Footer: Designed and developed with heart emoji by me


const ClienttttttWithFooter = () => (
  <>
    <Clientttttt />
    {/* <Footer /> */}
  </>
);

export default ClienttttttWithFooter;